module.exports = __webpack_public_path__ + "static/media/BizTech2.66e3b136.jpg";